export const mutations = {
    setBlogs: ( state, payload ) => {
        state.blogs = payload;
    },
};